<template lang="html">
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Atribuir indicação para um representante"
    type-modal="assign_lead_modal"
  >
    <d-form-row>
      <d-col md="12" class="form-group">
        <label for="feReseller">Representante</label>
        <autocomplete
          ref="reseller"
          placeholder="Representante"
          item-show="name"
          :items="resellers"
          :on-input="onInput"
          :on-select="saveReseller"
        ></autocomplete>
      </d-col>
    </d-form-row>
    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-3"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Atribuir</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Autocomplete from '_shared/Autocomplete.vue';
import ModalTemplate from '_shared/Modal.vue';
import ResellerService from '_services/rest/modules/reseller';
import LeadService from '_services/rest/modules/lead';

export default {
  name: 'assign-modal',
  components: {
    Autocomplete,
    ModalTemplate,
  },
  props: {
    lead: {
      type: Object,
    },
  },
  data() {
    return {
      resellers: [],
      selectedReseller: null,
    };
  },
  methods: {
    ...mapActions([
      'getLead',
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'assign_lead_modal', bool: false });
    },
    onInput(search) {
      const params = {
        search,
        skip: 0,
        take: 10,
        page: 1,
      };
      ResellerService.getList(params)
        .then(response => {
          this.resellers = response.list;
        });
    },
    saveReseller(reseller) {
      this.selectedReseller = reseller;
    },
    save() {
      LeadService.changeReseller(this.selectedReseller.id, this.lead.id)
        .then(() => {
          this.close();
          this.getLead(parseInt(this.$route.params.leadId, Number));
          this.activeAlert({ message: 'Indicação atribuída com sucesso', theme: 'success' });
        });
    },
  },
  beforeCreate() {},
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>
